<button class="app-nav__icon-btn" [matMenuTriggerFor]="notificationMenu" (click)="loadNotifications()" title="Notifications">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-bell"></use></svg>
    @if (hasUnread) {
        <span class="app-nav__icon-dot"></span>
    }
</button>

<mat-menu #notificationMenu="matMenu" class="notification-panel-menu">
    <div class="notification-panel" (click)="$event.stopPropagation()">
        <div class="notification-panel__header">
            <span>Notifications</span>
            <div class="notification-panel__header-actions">
                @if (hasUnread) {
                    <button type="button" class="notification-panel__clear" (click)="markAllAsRead()">Mark all as read</button>
                }
                @if (toasts.length) {
                    <button type="button" class="notification-panel__clear" (click)="clearAll()">Clear all</button>
                }
            </div>
        </div>

        @if (toasts.length) {
            <div class="notification-panel__list">
                @for (group of dayGroups; track group) {
                    <div class="notification-panel__day">{{ group.day }}</div>
                    @for (toast of group.toasts; track toast) {
                        <div class="notification-panel__item" (click)="onItemClick(toast)" (mouseenter)="markAsRead(toast)">
                            <span class="notification-panel__dot" [class.notification-panel__dot--unread]="!toast.read"></span>
                            <div class="notification-panel__body">
                                <div class="notification-panel__title" [class.notification-panel__title--unread]="!toast.read">
                                    {{ toastService.toastTitle(toast.type) }}
                                </div>
                                <div class="notification-panel__detail">{{ toast.message }}</div>
                                <div class="notification-panel__time">{{ toast.timestamp | date: 'h:mm a' }}</div>
                            </div>
                            <button class="notification-panel__remove" title="Dismiss" (click)="removeToast(toast)">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><use href="#icon-close"></use></svg>
                            </button>
                        </div>
                    }
                }
            </div>
        } @else {
            <div class="notification-panel__empty">You're all caught up.</div>
        }
    </div>
</mat-menu>
